import StatusIndicator from "../components/StatusIndicator";
import { DownloadCsvIcon, DownloadPDFIcon } from "../constant/index";
import {
  amPmTimeFormat,
  formatNumberWithCommas,
  formattedDate,
} from "../helpers";
import moment from "moment";

// export const bookingTabs = [
//   {
//     label: "All Bookings",
//     value: 0,
//   },
//   {
//     label: "Pending Booking",
//     value: 3,
//   },
//   {
//     label: "Confirmed Booking",
//     value: 2,
//   },
//   {
//     label: "Cancelled Booking",
//     value: 1,
//   },
// ];
export const paymentMethods = [
  { label: "All", value: 0 },
  { label: "Cash", value: 1 },
  { label: "Card", value: 2 },
  { label: "Bank Transfer", value: 3 },
];
export const statusOptions = [
  { label: "All", value: 0 },
  { label: "Confirm", value: 1 },
  { label: "Pending", value: 3 },
  { label: "Cancel", value: 2 },
  { label: "Completed", value: 4 },
];
export const bookingStatusOptions = [
  { label: "Confirmed", value: 1 },
  { label: "Cancel", value: 2 },
  { label: "Pending", value: 3 },
];
export const paidOptions = [
  { label: "All", value: 0 },
  { label: "Paid", value: true },
  { label: "Unpaid", value: false },
];
export const bookingTypeOptions = [
  { label: "Normal", value: 1 },
  { label: "Maintenance", value: 2 },
  { label: "Marketing", value: 3 },
  { label: "Tournament", value: 4 },
  { label: "Corporate", value: 5 },
  { label: "Event", value: 6 },
  { label: "Training", value: 7 },
  { label: "VIP", value: 8 },
  { label: "Other", value: 9 },
];
export const bookingViewDetails = [
  {
    key: "playerFullName",
    label: "Name",
    command: (value, data) => {
      return (
        data?.bookingPlayers?.find((item) => item?.isPrimary)?.playerFullName ||
        "--"
      );
    },
  },
  {
    key: "playerCellNumber",
    label: "Phone Number",
    command: (value, data) => {
      return (
        data?.bookingPlayers?.find((item) => item?.isPrimary)
          ?.playerCellNumber || "--"
      );
    },
  },
  {
    key: "playerEmail",
    label: "Email",
    command: (value, data) => {
      return (
        data?.bookingPlayers?.find((item) => item?.isPrimary)?.playerEmail ||
        "--"
      );
    },
  },
  {
    key: "courtName",
    label: "Court Name",
  },
  {
    key: "locationAddress",
    label: "Location",
  },
  {
    key:"corporateName",
    label:"Corporate Name"
  },
  {
    key: "bookingDate",
    label: "Booking Date",
    command: (value, data) => {
      return `${formattedDate(value)}`;
    },
  },
  {
    key: "bookingDate",
    label: "Slot Time",
    command: (value, data) => {
      return `${amPmTimeFormat(data?.bookingStartTime)} - ${amPmTimeFormat(
        data?.bookingEndTime
      )}`;
    },
  },
  {
    key: "bookingStatusId",
    label: "Status",
    command: (value, data) => {
      return (
        <StatusIndicator
          bookingStatus={data?.bookingStatusId}
          bookingDate={data?.bookingDate}
          bookingEndTime={data?.bookingEndTime}
          action={false}
        />
        //   bookingStatusOptions?.find(
        //     (item) => item?.value === data?.bookingStatusId
        //   )?.label || "--"
        // );
      );
    },
  },
  {
    key: "bookingGrossAmount",
    label: "Gross Amount",
    command: (value) => {
      return formatNumberWithCommas(value);
    },
  },
  {
    key: "bookingNetAmount",
    label: "Net Amount",
    value: "Rs. 6,000",
    command: (value) => {
      return formatNumberWithCommas(value);
    },
  },
  {
    key: "bookingDiscountAmount",
    label: "Discount Amount",
    command: (value) => {
      return formatNumberWithCommas(value);
    },
  },

  {
    key: "bookingCollectedAmount",
    label: "Collected Amount",
    command: (value) => {
      return formatNumberWithCommas(value);
    },
  },
  {
    key: "bookingCollectedAmount",
    label: "Remaining Payment",
    command: (value, data) => {
      return formatNumberWithCommas(
        data?.bookingNetAmount - data?.bookingCollectedAmount
      );
    },
  },
  {
    key: "couponCode",
    label: "Coupon Code",
    command: (value, data) => {
      return value ? value : "--";
    },
  },
];
export const daysOfWeek = [
  { label: "Sunday", value: 0 },
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 },
];
export const statsPeriod = [
  { label: "Daily", value: 1 },
  { label: "Weekly", value: 2 },
  { label: "Monthly", value: 3 },
  { label: "Yearly", value: 4 },
];
export const downloadOptions = [
  {
    label: "CSV",
    value: "csv",
    icon: <DownloadCsvIcon />,
  },
  {
    label: "PDF",
    value: "pdf",
    icon: <DownloadPDFIcon />,
  },
];
